import { Button, Checkbox, Form } from 'antd';
import { UploadFile } from 'antd/lib';
import { FileUseCaseInterface } from 'application/usecases/FileUseCase';
import { AttachFileInfo } from 'domain/entities/FileEntity';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import UploadImage from './component/Upload';
interface props {
    fileUseCase: FileUseCaseInterface;
}
export const CU0601Page = ({ fileUseCase }: props) => {
    const dispatch = useAppDispatch();
    const userSlice = useAppSelector((state) => state.user);
    const navigate = useNavigate();
    const { settlementId, dealId } = useParams();
    const [form] = Form.useForm();
    const [initFiles, setInitFiles] = useState<UploadFile[]>([]);
    const [isDisable, setIsDisable] = useState(true);

    useEffect(() => {
        if (settlementId) {
            getFiles();
        }
    }, [settlementId]);
    const submit = async () => {
        const payload = {
            dealId: Number(dealId),
            scheduleAdjustmentDiv: userSlice.implementerClassification ?? BUYER_CLASSIFICATION,
        };
        try {
            dispatch(startFetching());
            const response = await fileUseCase.confirmPayment(payload);
            if (response.status == 200) {
                openSuccessNoti({ description: getMessage('S0322') });
                //TODO
                navigate(-1);
            }
        } catch (error) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const getFiles = async () => {
        if (settlementId) {
            try {
                dispatch(startFetching());
                const params = {
                    settlementId: Number(settlementId),
                    scheduleAdjustmentDiv:
                        userSlice.implementerClassification ?? BUYER_CLASSIFICATION,
                };
                const response = await fileUseCase.getFilePayment(params);
                const fileInsurance = response?.result;
                const initFiles: UploadFile[] = [];
                if (fileInsurance) {
                    const fileArray =
                        params.scheduleAdjustmentDiv == BUYER_CLASSIFICATION
                            ? fileInsurance?.fileBillBuyer
                            : fileInsurance?.fileBillSeller;
                    const mapArray = fileArray?.map((item: AttachFileInfo) => {
                        return {
                            uid: item.attachmentFile.id + '',
                            url: item.pathFile,
                            name: item.attachmentFile.fileName,
                            status: 'done',
                        } as UploadFile;
                    });
                    if (mapArray) {
                        initFiles.push(...mapArray);
                    }
                }
                setInitFiles(initFiles);
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="cu-043-01"
        >
            <PageTitle title="精算内容の確認" showTypeSelect={false} disableSelect={true} />
            <Form
                className="width-full-screen center-inside CU-001-04-container pr-40"
                style={{
                    height: '100vh',
                }}
                onFinish={submit}
                form={form}
            >
                <div style={{ width: 343 }}>
                    <section style={{ width: '100%', marginBottom: 11 }}>
                        <UploadImage initFile={initFiles} />
                    </section>
                    <Checkbox
                        className="mb-[10px]"
                        onChange={(e) => {
                            setIsDisable(!e.target.checked);
                        }}
                    >
                        精算書の内容について同意します。
                    </Checkbox>
                    <Button
                        className="button-login-text"
                        type="primary"
                        style={{ width: '100%', height: 56, letterSpacing: -1.5 }}
                        htmlType="submit"
                        disabled={isDisable}
                    >
                        送信する
                    </Button>
                </div>
            </Form>
        </div>
    );
};
